import { createFileRoute } from '@tanstack/react-router'
import { NetworkOperationsDashboard } from '@/components/dashboard/NetworkOperationsDashboard'

export const Route = createFileRoute('/_app/share/message/$token')({
  component: SharedMessagePage,
})

function SharedMessagePage() {
  return <NetworkOperationsDashboard />
}
